<template>
    <v-flex class="profile-score" v-if="isCurrentUser && title.length > 0">
        <v-flex tag="strong">{{memberProfileConstants.YOUR_PROFILE_EFFECTIVENESS_SCORE}}
            <!-- TODO: Once we are able to calculate the profile percentage. we will uncomment below lines -->
            <!-- <span><v-progress-circular :rotate="-90" :value="profileInformation.percentageProfileComplete" :size="25" :width="4" background-color="white" color="ypo_gold"/> 
                {{profileInformation.percentageProfileComplete}}{{memberProfileConstants.PROFILE_PERCENTAGE}}
            </span> -->
        </v-flex>
        <span>{{memberProfileConstants.INCREASE_YOUR_PROFILE_SCORE_NOW}} <em>{{title[0].key}}</em></span>
        <v-flex class="file-upload" data-qe-id="open_file_upload_link" @click="openDialog(title[0].dialog)">
            <span class="file-upload__photo-btn">
                <i :class="title[0].icon"></i>
                <i class="fas fa-cloud-upload-alt"></i>
            </span>
            <em>{{title[0].mainSubtitle}}</em>
            <small>{{title[0].shortSubtitle}}</small>
        </v-flex>
    </v-flex>
</template>

<script>
    import { memberProfileConstants } from "./memberProfile.constants.js";
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { eventBus } from '../../main';

    export default {
        name: "ProfileEffectiveness",
        data: () => ({
            memberProfileConstants,
            title: [],
        }),
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        methods: {
            openDialog(dialog) {
                eventBus.$emit(dialog, true); // emit the event to the bus
            },
            getWizardsList() {
                this.title = [];
                const values = this.wizards.filter(x => x.isEmpty === true);
                if (values.length > 0) {
                    this.title.push(values[0]);
                }
            },
        },
        computed: {
            ...mapGetters({
                wizards: `memberProfile/${storeGetters.wizards}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                userProfileImageExists: `memberProfile/${storeGetters.userProfileImageExists}`,
                educationDetails: `memberProfile/${storeGetters.educationDetails}`,
                businessInterests: `memberProfile/${storeGetters.familyInterests}`,
                professionalExperience: `memberProfile/${storeGetters.professionalExperience}`,
                biographyInformation: `memberProfile/${storeGetters.biographyInformation}`,
                profileInformation: `myAccount/${storeGetters.profileInformation}`,
                contactInformation: `memberProfile/${storeGetters.contactInformation}`,
            }),
            isCurrentUser() {
                return this.memberId === this.currentUserId;
            },
        },
        watch: {
            userProfileImageExists(val) { 
                this.wizards[0].isEmpty = !val; 
                this.getWizardsList();
            },
            contactInformation() {
                this.wizards[1].isEmpty = !this.contactInformation.email;
                this.wizards[2].isEmpty = !(this.contactInformation.countryCode && this.contactInformation.businessPhone && this.contactInformation.businessPhoneOnProfile) && !(this.contactInformation.homePhoneCountryCode
                                    && this.contactInformation.homePhone && this.contactInformation.homePhoneOnProfile) && !(this.contactInformation.mobilePhoneCountryCode && this.contactInformation.mobilePhone && this.contactInformation.mobilePhoneOnProfile)
                                    && !(this.contactInformation.otherPhoneCountryCode && this.contactInformation.otherPhone && this.contactInformation.otherPhoneOnProfile);

                this.wizards[3].isEmpty = !(this.contactInformation.address1Type && this.contactInformation.mailingCountry && this.contactInformation.mailingStreet && this.contactInformation.mailingCity
                                    && this.contactInformation.mailingPostalCode && !this.contactInformation.isAddress1Private) && !(this.contactInformation.address2Type 
                                    && this.contactInformation.otherCountry && this.contactInformation.otherStreet && this.contactInformation.otherCity && this.contactInformation.otherPostalCode 
                                    && !this.contactInformation.isAddress2Private);

                this.wizards[15].isEmpty = !this.contactInformation.facebookURL && !this.contactInformation.instagram && !this.contactInformation.twitterUrl
                                    && !this.contactInformation.whatsApp && !this.contactInformation.linkedIn
                                    && !this.contactInformation.skype;
                this.getWizardsList();
            },
            educationDetails() {
                this.wizards[4].isEmpty = !this.educationDetails.length > 0;
                this.getWizardsList();
            },
            businessInterests() {
                if (this.businessInterests.Business && this.businessInterests.Business.length > 0) {
                    const expertiseCount = this.businessInterests.Business.filter(x => x.typePersonSkill === memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE).length;
                    const businessInterestCount = this.businessInterests.Business.filter(x => x.typePersonSkill === memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST).length;
                    const personalInterestCount = (this.businessInterests.Personal_Family && Array.isArray(this.businessInterests.Personal_Family)) 
                        ? this.businessInterests.Personal_Family.filter(x => x.typePersonSkill === memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST).length 
                        : 0;

                    const totalInterestCount = businessInterestCount + personalInterestCount;

                    this.wizards[5].isEmpty = !expertiseCount; 
                    this.wizards[6].isEmpty = !totalInterestCount;
                } else {
                    this.wizards[5].isEmpty = true;
                    this.wizards[6].isEmpty = true;
                }
                this.getWizardsList();
            },
            professionalExperience() {
                if (this.professionalExperience && this.professionalExperience.length > 0) {
                    const primary = this.professionalExperience.filter(item => item.isPrimary === true && item.isActive === true).length > 0 ?
                    this.professionalExperience.filter(item => item.isPrimary === true && item.isActive === true)[0] :
                    this.professionalExperience.filter(item => item.isActive === true)[0];
                    this.wizards[7].isEmpty = !primary.jobTitle;
                    this.wizards[8].isEmpty = !primary.street && !primary.city && !primary.postalCode && !primary.country;
                    this.wizards[9].isEmpty = !primary.companySize;
                    this.wizards[10].isEmpty = !primary.presidentType;
                    this.wizards[11].isEmpty = !primary.scopeofBusiness;
                    this.wizards[12].isEmpty = !primary.companyType;
                    this.wizards[13].isEmpty = !primary.industryCategory1;
                } else {
                    for (let i = 7; i <= 13; i += 1) {
                        this.wizards[i].isEmpty = true;
                    }
                }
                this.getWizardsList();
            },
            biographyInformation() {
                this.wizards[14].isEmpty = !this.biographyInformation || this.biographyInformation === " ";
                this.getWizardsList();
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .profile-score {
        border-radius: 4px;
        background-color: $ypo-blue;
        box-shadow: 0 0 3px 0 rgba($black, 0.5);
        padding: 20px;
        margin-bottom: 20px;
        text-align: center;

        strong {
            color: $white;
            font-size: 14px;
            font-weight: bold;
            line-height: 24px;
            display: block;
            margin-bottom: 20px;

            span {
                color: $white;
                font-size: 30px;
                display: inline-block;
                margin-left: 10px;
                vertical-align: bottom;
            }
        }

        span {
            display: block;
            color: rgba($white, 0.7);

            em {
                font-style: normal;
                opacity: 1;
                color: $white;
            }
        }

        .file-upload {
            background: $ypo-extra-light-gray;
            padding: 30px 20px;
            box-shadow: 0 0 3px 0 rgba($black, 0.5);
            border-radius: 4px;
            margin-top: 15px;
            cursor: pointer;
            
            .fa-cloud-upload-alt {
                color: $ypo-blue;
                font-size: 20px;
                position: absolute;
                left: 50%;
                bottom: -9px;
                margin-left: -15px;
                background: $white;
                padding: 3px;
                border-radius: 50%;
            }

            &__placeholder {
                color: $ypo-dark-background-gray;
                font-size: 80px;
            }

            &__photo-btn {
                position: relative;
                margin-bottom: 20px;
            }

            em {
                display: block;
                font-style: normal;
                font-weight: bold;
                color: $ypo-cta;
                font-size: 16px;
            }

            small {
                color: $ypo-cta;
                font-size: 14px;
            }

        }
        @media (max-width: 1199px) {
            strong span {
                margin-top: 15px;
            }
            em {
                display: block;
                margin-top: 10px;
            }        
        }
        @media (max-width: 767px) {
            padding: 10px;
        }
    }
</style>
